<template>
    <v-container>
        <v-row justify="center">
            <v-col cols="3">
                <v-btn dark color="blue darken-1" @click="handleShowRegisterEntry">
                    <v-icon class="mr-2">fas fa-download</v-icon>
                    Registrar Ingreso
                </v-btn>
            </v-col>
            <v-col cols="3">
                <v-btn dark color="green darken-1" @click="handleShowRegisterOutput">
                    <v-icon class="mr-2">fas fa-upload</v-icon>
                    Registrar Salida
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <template>
                        <v-row>
                            <v-col cols="12">
                                <v-data-table
                                    class="wost-table"
                                    :headers="headers"
                                    :items="supplies"
                                    hide-default-footer
                                    item-key="name"
                                    :search="search"
                                >
                                    <template v-slot:item.category_id="{ item }">
                                        {{ item.category.name }}
                                    </template>
                                    <template v-slot:item.unit_id="{ item }">
                                        {{ item.unit.name }}
                                    </template>                                    
                                    <template v-slot:item.action="{ item }">
                                            <v-btn small @click="handleViewKardex(item)">
                                                Kardex
                                            </v-btn>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </template>
                </v-card>
            </v-col>
        </v-row>
        <Entry ref="entry"/>
        <Output ref="output" />
    </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import Entry from '../../components/Production/Entry'
import Output from '../../components/Production/Output'

export default {
    name: 'Production',
    components: {
        Entry,
        Output
    },
    computed: {
        ...mapState('production', [
            'supplies'
        ])
    },
    data(){
        return {
            search: '',
            headers: [
                { text: 'Descripción', value: 'name', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Categoría', value: 'category_id', align: 'left', sortable: false, class: 'header-table', width: 120 },
                { text: 'Und. de medida', value: 'unit_id', align: 'left', sortable: false, class: 'header-table', width: 140 },
                { text: 'Stock', value: 'stock', align: 'a-right', sortable: false, class: 'header-table', width: 170 },
                { text: 'Acciones', value: 'action', sortable: false, class: 'header-table', width: 35 },
                { text: '', value: 'data-table-expand', width: 10, class: 'header-table-expand' }
            ]
        }
    },
    methods: {
        ...mapActions('production', [
            'getSupplies'
        ]),
        handleViewKardex(supplie){
            console.log('ver kardex')
        },
        handleShowRegisterEntry(){
            this.$refs.entry.showForm('Nuevo Ingreso de Insumos')
        },
        handleShowRegisterOutput(){
            this.$refs.output.showForm('Salida de Insumos')
        }
    },
    mounted(){
        this.getSupplies()
    }
}
</script>

<style>
.header-table-production{
    background-color: #3949AB !important;
    color: #ffffff !important;
    text-transform: uppercase;
    line-height: 30px;
}
</style>